module.exports = __webpack_public_path__ + "static/cyber-4ea973c0d76d40fe76113916c38aa564.png";